export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FreightPrice.vue?vue&type=template&id=46b5db25"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/FreightPrice.vue?vue&type=template&id=46b5db25
// module id = 2310
// module chunks = 31